import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";

const TimesheetBarChart = ({ projectName, timesheetData }) => {
  // Calculate booked hours per user
  const userBookedHours = useMemo(() => {
    const hoursByUser = {};
    timesheetData.forEach((entry) => {
      const { user_name, duration } = entry;
      const [hours, minutes] = duration.split(":").map(Number);
      const totalHours = hours + minutes / 60;

      // Accumulate hours by user name
      hoursByUser[user_name] = (hoursByUser[user_name] || 0) + totalHours;
    });

    return hoursByUser;
  }, [timesheetData]);

  // Generate unique color based on the index
  const generateColor = (index) => {
    const baseColors = ["#4BD5CE", "#FEC941", "#6482C3", "#197FC7", "#56B6FC"];
    if (index < baseColors.length) return baseColors[index];

    // Generate a unique color variation using HSL manipulation
    const hueShift = (index * 137) % 360; // Spread colors evenly across hue spectrum
    return `hsl(${hueShift}, 60%, 65%)`; // Pastel-midtone color
  };

  // Prepare data for the Bar chart
  const userNames = Object.keys(userBookedHours);
  const chartData = userNames.map((user, index) => ({
    name: user,
    value: userBookedHours[user],
    itemStyle: { color: generateColor(index) }, // Dynamic color based on index
  }));

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "8%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: userNames, // User names on the x-axis
        axisTick: {
          alignWithLabel: true,
        },
        axisLabel: {
          fontFamily: '"Lato", sans-serif',
          fontSize: 11,
          color: "#000",
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        axisLabel: {
          fontFamily: '"Lato", sans-serif',
          fontSize: 13,
          color: "#000",
        },
      },
    ],
    series: [
      {
        name: "Booked Hours",
        type: "bar",
        barWidth: "60%",
        data: chartData.map((data) => ({
          value: data.value,
          itemStyle: data.itemStyle, // Apply dynamic color to bars
          label: {
            show: true,
            position: "top", // Show the booked hours value on top of the bars
            color: "#000",
            fontSize: 12,
            fontFamily: '"Lato", sans-serif',
          },
        })),
      },
    ],
  };

  return (
    <div className="project-bar-status">
      <h2 className="pie-header">User's Summary</h2>
      <p style={{ fontSize: "14px", position: "relative", top: "-18px" }}>
        User's Count: {userNames.length}
      </p>
      {chartData.length > 0 && (
        <p className="bar-chart-text" style={{ left: "0rem" }}>
          Hours
        </p>
      )}
      {chartData.length > 0 && <p className="bar-chart-text-bottom">Users</p>}
      {chartData.length > 0 ? (
        <ReactECharts
          className="bar-chart"
          option={option}
          style={{
            height: "400px",
            bottom: "1rem",
          }}
        />
      ) : (
        <div className="duration-image-container dashboard-image-extra">
          <img
            className="duration-image"
            src="/AppLayout/User-booked.png"
            alt="No Data Available"
          />
          <p>Planned hours not available for this project</p>
        </div>
      )}
    </div>
  );
};

export default TimesheetBarChart;
